import { render } from "./AlertPop.vue?vue&type=template&id=79a46585"
import script from "./AlertPop.vue?vue&type=script&lang=js"
export * from "./AlertPop.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__